/* eslint-disable react/no-unescaped-entities */
import React from "react";

import Image from "../../../components/image";

const ProgramHighlights = ({ highlights }) => {
  return (
    <>
      <section className="w-full mr-auto border-t border-gray-standard md:border-black-quaternary tab-content">
        <div className="grid grid-cols-1 md:grid-cols-2 space-between items-center gap-8 pt-10 pb-3 sm:pb-8">
          <div className="flex highlight-image h-full w-full items-center justify-center">
            <Image
              imageAlt={"highlight-image"}
              image={highlights?.featured_image?.sourceUrl}
              imageClass={
                "h-full object-cover object-center w-full rounded-3xl max-h-48 sm:max-h-72"
              }
              sourceUrl={highlights?.featured_image?.sourceUrl}
            />
          </div>
          <div className="flex flex-col space-between">
            <div
              className="block pb-3 font-light text-black-lighter dark:font-bold text-xl sm:text-xlrg-sm dark:text-gray-dark "
              dangerouslySetInnerHTML={{
                __html: highlights?.heading
              }}
            />
            <div
              className=" sm:flex pb-5 text-mob md:text-base text-generic-text dark:text-gray-generic"
              dangerouslySetInnerHTML={{
                __html: highlights?.sub_heading
              }}
            />
            <div
              className="block pb-3 font-light text-black-lighter dark:font-bold text-xl sm:text-xlrg-sm dark:text-gray-dark"
              dangerouslySetInnerHTML={{
                __html: highlights?.title
              }}
            />
            {highlights?.highlights?.length > 0 &&
              highlights?.highlights.map((highlight, index) => (
                <div
                  className="highlight-item text-mob md:text-base text-generic-text dark:text-gray-generic"
                  key={`highlight-item-${index}`}
                  dangerouslySetInnerHTML={{
                    __html: highlight?.highlightText
                  }}
                />
              ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ProgramHighlights;
